<template>
	<tr v-if="product.product_id>0" class="product-analytics-row"
	    :class="{deleted: product.is_deleted}" :data-id="product.product_id">
		<td>
			<div class="page-name">
				<strong v-if="product.is_deleted" class="name">{{ product.name }}</strong>

<!--				<router-link v-else :to="'/wfunnel/'+$route.params.id+'/steps/'+page.step_id">-->
					<strong v-else-if="product.name" class="name">{{ product.name }}</strong>
					<strong v-else class="name empty"><i>UNKNOWN PRODUCT</i></strong>
<!--				</router-link>-->
			</div>
		</td>

		<td class="conv-rate-td">
			<span class="bar"
			      :style="`width:${Math.max(1, Math.min(percentage(product.orders, page.unique_visits), 100))}%`" />
			<value-diff :value="percentage(product.orders, page.unique_visits)"
			            no-old-value suffix="%" :digits="2" />
		</td>

		<td >
			<value-diff :value="product.revenue" no-old-value :prefix="currencyCode" is-money />
		</td>
		<td >
			<value-diff :value="product.orders" no-old-value suffix="" />
		</td>
		<td >
			<!--			<value-diff :value="page.unique_visits" no-old-value suffix="" />-->
		</td>
		<td> <!-- pageviews --> </td>
		<td></td>
		<td></td>
	</tr>

<!--	hidden pages entry -->
	<tr v-else class="product-analytics-row empty" :class="{deleted: product.is_deleted}" >
		<td>
			<div class="page-name">
				<strong class="name">
<!--					:label="showHiddenPages?'Hide deleted products':`Show deleted products`"-->
					<v-button class="show-more" flat slim
					          @click="$emit('showMore')" >
<!--						<inline-svg :src="require('@/assets/img/plus_icon_gray.svg')" />-->
						<inline-svg class="arrow" :class="{open:showHiddenPages}" :src="require('@/assets/img/arrow-bottom.svg')" />
					</v-button>
				</strong>
			</div>
		</td>
		<td ></td>
		<td ></td>
		<td ></td>
		<td ></td>
		<td ></td>
		<td ></td>
	</tr>
</template>

<script>
import ValueDiff from "@/views/funnels/funnel/valueDiff";
import {percentage} from "@/helpers/analytics";
import {mapGetters} from "vuex";
import {getSymbol} from "@/helpers/currencies";
import VButton from "@/components/base/v-button";

export default {
	name: "ProductAnalyticsRowV2", components: {VButton, ValueDiff},
	props: ["product", "page","showHiddenPages"],
	data() {
		return {}
	},
	computed:{
		...mapGetters(["getFunnelStore",]),
		currencyCode() {
			let currency = this.getFunnelStore.currency_code;
			return getSymbol(currency);
		},
	},
	methods:{
		percentage(sub,total) {
			return percentage(sub,total)
		},
	}
}
</script>

<style lang="scss" scoped>
.product-analytics-row {
	td:first-child::before {
		content: "";
		display: flex;
		height: 100%; // calc(100% - 10px);
		left: 30px;
		top: 0;
		//top: 50px;
		width: 2px;
		background: #ebeff5;
		position: absolute;
		z-index: 2;
		//bottom: -10px;
	}

	a.show-more {
		border-radius: 20px;
		border: 1px solid #b0b4ba;
		padding: 1px;
		color: #8f9092;
		width: 20px;
		height: 20px;
		//left: 8px;
		//top: -13px;
		z-index: 2;
		background: white;
		top: -10px;
		left: -22px;

		.arrow {
			margin: auto;
			top: calc(50% - 7px);
			left: calc(50% - 7px);
			&.open {
				transform: rotate(180deg);
			}
		}
	}
	//&.empty {
	//	.page-name {
	//		&::before {
	//			content: "";
	//			display: flex;
	//			background: transparent;
	//			width: 0;
	//			height: calc(50%);
	//			left: 20px;
	//			position: absolute;
	//			top: calc(-50% + 0px);
	//			border-bottom: 2px solid red;
	//			border-left: 2px solid red;
	//		}
	//	}
	//	td {
	//		height: 14px;
	//		padding: 0;
	//		padding-left: 0!important;
	//	}
	//}
	&.empty {
		&:last-child td:first-child::before {
			content: "";
			display: none;
			//height: 100%; // calc(100% - 10px);
			left: 30px;
			top: 0;
			//top: 50px;
			width: 3px;
			height: 3px;
			border-radius: 10px;
			background: silver;
			position: absolute;
			z-index: 2;
			//bottom: -10px;
		}
		.page-name, .page-name .name {
			margin-left: 0;
			overflow: visible;
			&:before {
				display: none;
			}
		}
		td {
			border-right: none;
			background: transparent;
			height: 5px;
			min-height: 0;
			max-height: 5px;
			padding: 0;
		}
		td:first-child {
			background: white !important;
		}
	}


	.page-name {
		&::before {
			content: "";
			display: flex;
			width: 6px;
			left: -15px;
			position: absolute;
			top: calc(50% - 3px);
			background: grey;
			border-radius: 15px;
			height: 6px;
		}
	}
	.page-name {
		position: relative;
		.name {
			font-weight: 500;
			font-size: 13px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: #252A32;
			white-space: nowrap;
			max-width: 300px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: block;
		}
	}

	td {
		background: white;
		border-top: none;
	}

	&:hover:not(.empty) {
		td {
			background: #e6e6ea !important;
		}
	}
	&.empty {
		td {
			border-right: none;
			background: transparent;
		}
		td:first-child {
			background: white !important;
		}
	}
	td:first-child {
		//background: white !important;
		padding-left: 80px;
	}

	&.deleted {
		.page-name {
			.name {
				color: #8f8f8f;
			}
			&::before {
				background: silver;
			}
		}
	}
}
</style>
